<template>
	<section class="small-12 residentsStats flex border borderRadius8 widget">
        <div class="small-12 columns animated fadeIn">
            <h3 class="small-12 flex vertical-align">
                {{ currentMonth }} <span class="round"></span> Payments Breakdown
            </h3>
        </div>
        <div class="small-12 columns border-bottom payments flex animated fadeIn">
            <div class="small-12 large-5">
                <div class="small-12 chartContainer">
                    <div class="small-12 columns chart chart-line-s" style="margin-top:10px;" v-if="chartData && chartOptions">
                        <div class="small-12 wrap">
                            <pie-chart :chartOptions="chartOptions" :chartData="chartData"></pie-chart>
                        </div>
                    </div>
                    <div class="small-12 totalPercent flex vertical-align justify-center">
                        <div class="small-12 flex justify-center">
                            <h2 class="small-12 text-center">{{ totalRevenueEarnedPercentage }}%</h2>
                            <p class="small-12 text-center" style="line-height:1;">earned of<br/> total income</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="small-12 large-7 flex">
                <div class="small-12 meterContainer">
                    <div class="small-12 goalTitle flex vertical-align">
                        <div class="small-8">
                            <p class="small-12 text-overflow">
                                Payments Pending
                            </p>
                        </div>
                        <div class="small-4 flex justify-right">
                            <p class="completionPercentage">${{ pending_invoices_total_amount | convertCentsToDollars }}</p>
                        </div>
                    </div>
                    <meter-gauge :colorClass="'bgYellow'" :percentage="pendingPaymentsPercentage"/>
                </div>
                <div class="small-12 meterContainer">
                    <div class="small-12 goalTitle flex vertical-align">
                        <div class="small-8">
                            <p class="small-12 text-overflow">
                                Successful Payments
                            </p>
                        </div>
                        <div class="small-4 flex justify-right">
                            <p class="completionPercentage">${{ paid_invoices_total_amount | convertCentsToDollars }}</p>
                        </div>
                    </div>
                    <meter-gauge :colorClass="'bgSecondaryPurpleLight'" :percentage="totalRevenueEarnedPercentage"/>
                </div>
                <div class="small-12 meterContainer">
                    <div class="small-12 goalTitle flex vertical-align">
                        <div class="small-8">
                            <p class="small-12 text-overflow">
                                Failed Payments
                            </p>
                        </div>
                        <div class="small-4 flex justify-right">
                            <p class="completionPercentage">${{ failed_invoices_total_amount | convertCentsToDollars }}</p>
                        </div>
                    </div>
                    <meter-gauge :colorClass="'bgSalmon'" :percentage="failedPaymentsPercentage"/>
                </div>
            </div>
        </div>
        <div class="small-12 large-4 columns animated fadeIn">
            <article class="small-12 borderRadius8 quickStat">
                <div class="small-2 statIcon">
                    <i class="material-icons">monetization_on</i>
                </div>
                <div class="small-10 columns">
                    <div class="small-12 title">
                        <p class="small-12">
                            Total Income
                        </p>
                    </div>
                    <div class="small-12 stat">
                        <h2>{{ totalInvoicesCount }} <span>invoices</span></h2>
                    </div>
                    <div class="small-12 date">
                        <small>${{ total_monthly_revenue | convertCentsToDollars }}</small>
                    </div>
                </div>
            </article>
        </div>
        <div class="small-12 large-4 columns border-left border-right animated fadeIn">
            <article class="small-12 borderRadius8 quickStat">
                <div class="small-2 statIcon">
                    <i class="material-icons">pending</i>
                </div>
                <div class="small-10 columns">
                    <div class="small-12 title">
                        <p class="small-12">
                            Outstanding Income
                        </p>
                    </div>
                    <div class="small-12 stat">
                        <h2>{{ totalOpenCount }} <span>invoices</span></h2>
                    </div>
                    <div class="small-12 date">
                        <small>${{ open_invoices_total_amount | convertCentsToDollars }}</small>
                    </div>
                </div>
            </article>
        </div>
        <div class="small-12 large-4 columns animated fadeIn">
            <article class="small-12 borderRadius8 quickStat">
                <div class="small-2 statIcon">
                    <i class="material-icons">assignment_late</i>
                </div>
                <div class="small-10 columns">
                    <div class="small-12 title">
                        <p class="small-12">
                            Late Invoices
                        </p>
                    </div>
                    <div class="small-12 stat">
                        <h2>{{ totalLateCount }} <span>invoices</span></h2>
                    </div>
                    <div class="small-12 date">
                        <small>${{ late_invoices_total_amount | convertCentsToDollars }}</small>
                    </div>
                </div>
            </article>
        </div>
    </section>
</template>

<script>

	// Import the components
    import PieChart from '@/components/framework/charts/PieChart.vue'
    import MeterGauge from '@/components/framework/helpers/MeterGauge.vue'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
    import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ResidentsStats',

		/*
		**  Register the components
		*/

		components: {

			PieChart,
            MeterGauge

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
            MoneyConversions

		],

		/*
		**  Set the props
		*/

		props: {

			residents: {
                type: Array,
                default: () => []
            },
            open_invoices: {
                type: Array,
                default: () => []
            },
            paid_invoices: {
                type: Array,
                default: () => []
            },
            pending_invoices: {
                type: Array,
                default: () => []
            },
            failed_invoices: {
                type: Array,
                default: () => []
            },
            late_invoices: {
                type: Array,
                default: () => []
            },
            all_invoices: {
                type: Array,
                default: () => []
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			chartOptions: null,
            chartSeries: [],
            chartData: null,
            total_monthly_revenue: 0,
            open_invoices_total_amount: 0,
            pending_invoices_total_amount: 0,
            paid_invoices_total_amount: 0,
            failed_invoices_total_amount: 0,
            late_invoices_total_amount: 0,
            totalRevenueEarnedPercentage: 0,
            pendingPaymentsPercentage: 0,
            totalRevenueEarnedPercentage: 0,
            failedPaymentsPercentage: 0

		}),

		/*
		**  Watch em'
		*/

		watch: {

			all_invoices: {

				immediate: true, // Load on created
				handler(all_invoices) {

                    /*
                    **  Calculate the total revenue
                    **  @method: @here
                    */

					if (all_invoices.length > 0) this.calculateTotalRevenue();

				}

			},

            total_monthly_revenue: {

				immediate: true, // Load on created
				handler(total_monthly_revenue) {

                    /*
                    **  Calculate the pending revenue
                    **  @method: @here
                    */

					if (total_monthly_revenue > 0 && this.pending_invoices.length > 0) this.calculatePendingRevenue();

                    /*
                    **  Calculate the paid revenue
                    **  @method: @here
                    */

					if (total_monthly_revenue > 0 && this.paid_invoices.length > 0) this.calculatePaidRevenue();

                    /*
                    **  Calculate the open revenue
                    **  @method: @here
                    */

					if (total_monthly_revenue > 0 && this.open_invoices.length > 0) this.calculateOpenRevenue();

                    /*
                    **  Set the empty chart
                    **  @method: @here
                    */

                    if (total_monthly_revenue == 0) this.setEmptyChart();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	/*
            **  Set the chart options
            **  @method: @here
            */

            this.setChartOptions();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			setEmptyChart: function() {

                try {

                    /*
                    **  Populate the chart data
                    **  @method: @here
                    */

                    this.chartData = {

                        labels: ['Money In', 'Remaining'],
                        datasets: [
                            {
                                backgroundColor: ['#d0d1d2'],
                                borderColor: '#ffffff',
                                data: [100, 0]
                            }
                        ]

                    };

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the empty chart.',
						errorType: 'Application',
						section: 'Residents Stats',
                        uid: 'Us4ma8EO5IkNsp70GzI3',
						error: e
					});

                }

            },

            setChartOptions: function() {

                try {

                    /*
                    **  Populate the options
                    **  @prop: @here
                    */

                    this.chartOptions = {
                        responsive: true, 
                        maintainAspectRatio: false,
                        legend: {
                            display: false,
                            position: 'right'
                        },
                        tooltips: {
                            enabled: false,
                        },
                        cutoutPercentage: 70
                    }

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the chart options.',
						errorType: 'Application',
						section: 'Residents Stats',
                        uid: 'eATLPdluRpul5vtUqI13',
						error: e
					});

                }

            },

            setChartData: function() {

                try {

                    /*
                    **  Set the vars
                    */

                    let paid_percent = (this.paid_invoices_total_amount / this.total_monthly_revenue * 100).toFixed(0),
                        remaining_percent = 100 - paid_percent;

                    /*
                    **  Populate the chart data
                    **  @method: @here
                    */

                    this.chartData = {

                        labels: ['Paid', 'Remaining'],
                        datasets: [
                            {
                                backgroundColor: ['#18bbf7', '#d0d1d2'],
                                borderColor: '#ffffff',
                                data: [String(paid_percent), String(remaining_percent)]
                            }
                        ]

                    };

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the chart data.',
						errorType: 'Application',
						section: 'Residents Stats',
                        uid: 'LQea5KpBvawIZYtxXV3l',
						error: e
					});

                }

            },

            calculateTotalRevenue: function() {

                try {

                    /*
					**  Reset the prop
                    **  @prop: @here
					*/

                    this.total_monthly_revenue = 0;

                    /*
					**  Loop through em'
					*/

                    this.all_invoices.forEach(document => {

                        this.total_monthly_revenue = this.total_monthly_revenue + document.invoice.attributes.charge.total;

                    });

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Calculate the total mothly revenue.',
						errorType: 'Application',
						section: 'Residents Stats',
                        uid: '8fF3Kq1LV8LvbmO2LKWe',
						error: e
					});

                }

            },

            calculatePendingRevenue: function() {

                try {

                    /*
					**  Reset the prop
                    **  @prop: @here
					*/

                    this.pending_invoices_total_amount = 0;

                    /*
					**  Loop through em'
					*/

                    this.pending_invoices.forEach(document => {

                        this.pending_invoices_total_amount = this.pending_invoices_total_amount + document.invoice.attributes.charge.total;

                    });

                    /*
                    **  Set the total percentage prop
                    */

                    if (this.pending_invoices_total_amount > 0) {

                        let percentage = (this.pending_invoices_total_amount / this.total_monthly_revenue * 100).toFixed(0);

                        if (percentage == 1) percentage = 100;

                        this.pendingPaymentsPercentage = Number(percentage);

                    }

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Calculate the pending mothly revenue.',
						errorType: 'Application',
						section: 'Residents Stats',
                        uid: 'ykCyFxBB6F7tjTLduKZ0',
						error: e
					});

                }

            },

            calculatePaidRevenue: function() {

                try {

                    /*
					**  Reset the prop
                    **  @prop: @here
					*/

                    this.paid_invoices_total_amount = 0;

                    /*
                    **  Set the total amount prop
                    */

                    this.paid_invoices.forEach(document => {

                        this.paid_invoices_total_amount = this.paid_invoices_total_amount + document.invoice.attributes.charge.total;

                    });

                    /*
                    **  Set the total percentage prop
                    */

                    if (this.paid_invoices_total_amount > 0) {

                        let percentage = (this.paid_invoices_total_amount / this.total_monthly_revenue * 100).toFixed(0);

                        if (percentage == 1) percentage = 100;

                        this.totalRevenueEarnedPercentage = Number(percentage);

                    }

                    /*
					**  Set the chart data
                    **  @method: @here
					*/

                    this.setChartData();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Calculate the paid mothly revenue.',
						errorType: 'Application',
						section: 'Residents Stats',
                        uid: 'yuxFMxTjJ9e63PQqKnUW',
						error: e
					});

                }

            },

            calculateFailedRevenue: function() {

                try {

                    /*
					**  Reset the prop
                    **  @prop: @here
					*/

                    this.failed_invoices_total_amount = 0;

                    /*
                    **  Set the total amount prop
                    */

                    this.failed_invoices.forEach(document => {

                        this.failed_invoices_total_amount = this.failed_invoices_total_amount + document.invoice.attributes.charge.total;

                    });

                    /*
                    **  Set the total percentage prop
                    */

                    if (this.failed_invoices_total_amount > 0) {

                        let percentage = (this.failed_invoices_total_amount / this.total_monthly_revenue * 100).toFixed(0);

                        if (percentage == 1) percentage = 100;

                        this.failedPaymentsPercentage = Number(percentage);

                    }

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Calculate the failed mothly revenue.',
						errorType: 'Application',
						section: 'Residents Stats',
                        uid: 'EijHkGMU29d8PlhR9BWm',
						error: e
					});

                }

            },

            calculateOpenRevenue: function() {

                try {

                    /*
					**  Reset the prop
                    **  @prop: @here
					*/

                    this.open_invoices_total_amount = 0;

                    /*
                    **  Set the total amount prop
                    */

                    this.open_invoices.forEach(document => {

                        this.open_invoices_total_amount = this.open_invoices_total_amount + document.invoice.attributes.charge.total;

                    });

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Calculate the failed mothly revenue.',
						errorType: 'Application',
						section: 'Residents Stats',
                        uid: 'EijHkGMU29d8PlhR9BWm',
						error: e
					});

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			currentMonth: function() {

                return moment().format('MMMM YYYY');

            },

            totalInvoicesCount: function() {

                return this.pending_invoices.length + this.open_invoices.length + this.failed_invoices.length + this.paid_invoices.length;

            },

            totalOpenCount: function() {

                return this.open_invoices.length;

            },

            totalLateCount: function() {

                return this.late_invoices.length;

            }

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>